// Pseudo / Planning Code.

// Note:
// The important item here is the {{ block.id }}
// (Usually in the form of 'block_61a8dc484ad12' )
// Each child-item will load like this: 'accordion-{{ block.id }}-{{ order_num }}', so a bit of filtering will be needed for 'a.' below.

// Select all parent-group elements where "<section class='accordion'>" AND the 'id' of each item.
// Foreach selected item:
// a. Select all elements with the class 'accordion-toggle'
// b. Watch for: .onClick for ( id="accordion-toggle-{{ block.id }}" ) WHERE it is not `:checked`
// Toggle `:checked` for all selected 'accordion-toggle' items.
// c. Watch for: .onClick for ( ... ) WHERE it is `:checked`.
// Toggle: `:checked` for all selected 'accordion-toggle' items.

window.onload = (event) => {
	// Get all Accordion groups.
	const allAccordions = document.querySelectorAll(".accordion");

	// Loop through each Accordion.
	[...allAccordions].forEach((accordionBlock) => {
		let blockID = accordionBlock.id;
		let expandAllString = "expand-all-" + blockID;
		let expandAllButton = document.getElementById(expandAllString);
		let partialAccordionClass = "accordion-" + blockID;
		let accordionChildren = document.querySelectorAll(
			'[id^="accordion-' + blockID + '"]'
		);

		// Loop through each child of A clicked accordion and open all items.
		document
			.getElementById(expandAllString)
			.addEventListener("click", function () {
				if ($(this).hasClass("accordion-collapsed")) {
					$(this).removeClass("accordion-collapsed");
					$(this).addClass("accordion-expanded");
					$(this).find(".expand-text").text("Collapse all");
					$(this).find(".icon").text("remove");
				} else {
					$(this).addClass("accordion-collapsed");
					$(this).removeClass("accordion-expanded");
					$(this).find(".expand-text").text("Expand all");
					$(this).find(".icon").text("add");
				}
				accordionChildren.forEach((e) => {
					if (
						$(e)
							.parentsUntil("#block-" + blockID + "")
							.find(".accordion-expandall-toggle")
							.hasClass("accordion-expanded")
					) {
						// e.checked = false;
						$(e)[0].checked = true;
						$(e).change();
					} else {
						// e.checked = true
						$(e)[0].checked = false;
						$(e).change();
					}
					// e.checked ^= 0
				});
			});
	});
};
